import type { StepConfig } from "@portal/components/multiform/types";
import type { AdminCombinedFormData } from "../../schema";
import { PrincipalStep } from "./PrincipalStep";
import { PrincipalSummary } from "./PrincipalSummary";

export const principalStepConfig: StepConfig<AdminCombinedFormData> = {
	name: "principal",
	label: "Principal",
	fieldPaths: ["agencyId", "agentId", "underwriterId", "followers"],
	component: PrincipalStep,
	summaryComponent: PrincipalSummary,
};
